import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import CraftingUnforgettableMemories from "./sections/CraftingUnforgettableMemories";
import MomentsCaptured from "./sections/MomentsCaptured";
import ThePlanningJourney from "./sections/ThePlanningJourney";
import CelebrationMilestones from "./sections/CelebrationMilestones";
import TheSignatureExperience from "./sections/TheSignatureExperience";
import KindWords from "./sections/KindWords";
import BookAConsultation from "./sections/BookAConsultation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <CraftingUnforgettableMemories />
      <MomentsCaptured />
      <ThePlanningJourney />
      <CelebrationMilestones />
      <TheSignatureExperience />
      <KindWords />
      <BookAConsultation />
      <Footer />
    </div>;
}